import { closingTimeExist, getClosingTime } from "@swiggy-private/core-ui";

interface UseCartTimerReturnType {
    isTimerValid: boolean;
    closeTimeInSeconds: number;
}

const useCartTimerFromStorage = (): UseCartTimerReturnType => {
    const closingTimeInStorage = closingTimeExist();
    const closeTime = getClosingTime();

    return {
        isTimerValid: closingTimeInStorage && closeTime > 0,
        closeTimeInSeconds: closeTime,
    };
};

export default useCartTimerFromStorage;
